<template>
  <v-data-table
      :headers="headers1"
      :items="deliveryBasises"
      :items-per-page="itemsPerPage"
      item-key="deliveryBasisRevisionId"
      class="elevation-1"
      disable-sort-by
      dense
      hide-default-footer
      :locale="systemLocale">
    <template v-slot:top>
      <v-row>
        <v-col class="pr-4 mr-3">
          <v-combobox
              v-if="!readonly"
              v-model="current"
              :loading="isLoading"
              item-value="deliveryBasisRevisionId"
              item-text="description"
              :items="filteredItems"
              :error-messages="errorMessages"
              :label="searchLabel"
              :readonly="readonly"
              :search-input.sync="search"
              :clearable="!readonly"
              prepend-icon="search"
              return-object
              eager
              dense>
            <template v-slot:prepend-inner>
              <v-icon
                  v-if="required"
                  small
                  left
                  :color="requiredColor">
                *
              </v-icon>
            </template>
            <template v-slot:append-outer>
              <btn-icon-tip
                  v-if="!readonly && canAdd"
                  id="addBtn"
                  :tip="$t('Добавить маршрут')"
                  icon-color="green"
                  icon="add"
                  @click="add" />
              <btn-icon-tip
                  v-if="!readonly && canClear"
                  id="clearBtn"
                  :tip="$t('Очистить список маршрутов')"
                  icon="delete_sweep"
                  @click="clear" />
            </template>
          </v-combobox>
        </v-col>
      </v-row>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.description="{ item }">
      {{ item.description }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.shippingCost="{ item }">
      <validatable-text-input
          v-if="!viewonly"
          :key="item.deliveryBasisRevisionId"
          v-model="item.shippingCost"
          data-type="float"
          dense
          :readonly="readonly"
          :label="$t('Расходы продавца по доставке покупателю')"
          :rules="{ required: true,
                    regex: /^[0-9]{1,11}([.][0-9]{0,2})?$/ }"
          hide-details="auto"
          :tabindex="1"
          :clearable="false"
          solo
          @change="shippingCostChanged" />
      <div v-if="viewonly">
        {{ item.shippingCost }}
      </div>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.deliveryBasisRevisionId="{ item }">
      <btn-icon-tip
          v-if="!readonly"
          :id="`deleteBtn-${item.deliveryBasisRevisionId}`"
          :tip="$t('Убрать из списка')"
          icon="cancel"
          @click="remove(item.deliveryBasisRevisionId)" />
    </template>
  </v-data-table>
</template>

  <script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import { mapState } from 'vuex'
  import { DICTIONARIES } from '@/constants/store.js'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'

  export default {
    components: {
      BtnIconTip,
      ValidatableTextInput
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      exclude: {
        type: Array,
        default: () => {
          return []
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      errorMessages: Array,
      label: {
        type: String,
        default: ''
      },
      searchLabel: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      viewonly: {
        type: Boolean,
        default: false
      },
      onlyRoute: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: -1,
        search: '',
        current: null,
        deliveryBasises: []
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        items: state => {
          return state[DICTIONARIES.STATE.DELIVERY_BASISES] || []
        }
      }),
      headers1 () {
        var h = [
          { text: this.$t('Наименование маршрута'), sortable: true, value: 'description' },
          { text: this.$t('Стоимость маршрута'), width: this.$vuetify.breakpoint.mdAndDown ? '40%' : '30%', sortable: true, value: 'shippingCost' },
          { text: '', sortable: false, value: 'deliveryBasisRevisionId' }
        ]

        if (this.onlyRoute) {
          h = h.filter(x => x.value !== 'shippingCost')
        }

        return h
      },
      canAdd () {
        return this.current &&
          this.current.hasOwnProperty('deliveryBasisId')
      },
      canClear () {
        return !!this.deliveryBasises.length
      },
      filteredItems () {
        if (this.readonly) {
          return []
        }

        let filteredItems = this.items.map(i => ({ ...i })) || []

        if (this.search &&
          (!this.canAdd || this.current.description !== this.search)) {
          return filteredItems.filter(r => r.description.includes(this.search))
        }
        if (this.current && this.current.deliveryBasisRevisionId) {
          filteredItems = filteredItems.filter(o => o.deliveryBasisRevisionId !== this.current.deliveryBasisRevisionId)
        }
        if (this.exclude && this.exclude.length) {
          filteredItems = filteredItems.filter(o => !this.exclude.includes(o.deliveryBasisRevisionId))
        }
        if (this.deliveryBasises && this.deliveryBasises.length) {
          filteredItems = filteredItems.filter(o => !this.deliveryBasises.some(i => i.deliveryBasisId === o.deliveryBasisId))
        }

        return filteredItems
      }
    },
    watch: {
      search (pattern) {
        if (!pattern) {
          this.current = null
        }
      },
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal) {
            this.deliveryBasises = newVal.map(i => ({ ...i }))
          }
        }
      }
    },
    created () {
    },
    methods: {
      remove: function (id) {
        const filtered = this.deliveryBasises.filter(o => o.deliveryBasisRevisionId !== id)
        this.deliveryBasises = filtered
        this.input(this.deliveryBasises)
      },
      add: function () {
        const vm = this
        if (!vm.deliveryBasises.find(io => io.deliveryBasisRevisionId === vm.current.deliveryBasisRevisionId)) {
          vm.deliveryBasises.push(vm.current)
          this.input(this.deliveryBasises)
        }
        this.current = null
      },
      input: function (deliveryBasises) {
        this.$emit('input', deliveryBasises)
        this.change(deliveryBasises)
      },
      shippingCostChanged: function () {
        this.input(this.deliveryBasises)
      },
      change: function (deliveryBasises) {
        this.$emit('change', deliveryBasises)
      },
      clear: function () {
        this.current = null
        this.deliveryBasises = []
        this.input([])
      }
    }
  }
  </script>
